module.exports = __webpack_public_path__ + "media/images/pais-7a2abce02f35f2469235b4106897b31a.png";